(ns dashboard.components.switch
  (:require
   [reagent.core :as reagent]
   [re-frame.core :as re-frame]
   [headlessui-reagent.core :as ui]
   [dashboard.utils :refer [cs listen]]
   [dashboard.subs :as subs]))

(defn switch [{:keys [name checked? on-change]}]
  [ui/switch
   {:class (cs "relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 mt-2"
               (if checked? "bg-primary-600" "bg-gray-200"))
    :aria-describedby name
    :aria-labelledby (str name "-label")
    :checked checked?
    :on-change on-change}
   [:span.sr-only
    name]
   [:span.pointer-events-none.inline-block.h-5.w-5.rounded-full.bg-white.shadow.transform.ring-0.transition.ease-in-out.duration-200
    {:aria-hidden true
     :class (if checked? "translate-x-5" "ranslate-x-0")}]])
